import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const ClockCircleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0zm0 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm.5 3v5.2l4.5 2.7-.8 1.3L9 11V5h1.5z"
        fill={props.htmlColor || '#D7A300'}
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default ClockCircleIcon;
